import { NgModule } from '@angular/core';
import { SessionTimeoutModalComponent } from './session-timeout-modal.component';
import { EdAssistUIModalModule } from '../modal';
import { EdAssistUIParagraphModule } from '../paragraph';
import { CommonModule } from '@angular/common';
import { EdAssistUIPipesModule } from '../pipes';

const COMPONENTS = [SessionTimeoutModalComponent];

@NgModule({
	imports: [
		EdAssistUIModalModule,
		CommonModule,
		EdAssistUIParagraphModule,
		EdAssistUIPipesModule
	],
	exports: COMPONENTS,
	declarations: [COMPONENTS]
})
class EdAssistUISessionTimeoutModalModule {}

export { EdAssistUISessionTimeoutModalModule, SessionTimeoutModalComponent };
